import React from "react";
import cn from "classnames";

import { HeadingProps } from "../Heading.props";
import styles from "./H5.module.scss";

/**
 * @deprecated
 */
const H5: React.FC<HeadingProps> = ({ children, id, testId, className, roboto, large, semiBold }: HeadingProps): JSX.Element => {
  const headerClasses = cn(
    styles["h5"],
    { [styles["roboto"]]: roboto },
    { [styles["large"]]: large },
    { "semi-bold": semiBold },
    className,
  );

  return (
    <h5 className={headerClasses} id={id} data-testid={testId ? `test__${testId}` : undefined}>
      {children}
    </h5>
  );
};

/**
 * @deprecated
 */
export default H5;
